var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "huobu_title" }, [_vm._v("非特殊订单")]),
      _c(
        "el-form",
        { ref: "form", attrs: { inline: "", model: _vm.form } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { md: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "orderCode" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入订单编码" },
                        model: {
                          value: _vm.form.orderCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "orderCode", $$v)
                          },
                          expression: "form.orderCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { md: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "productCode" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入产品编码" },
                        model: {
                          value: _vm.form.productCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "productCode", $$v)
                          },
                          expression: "form.productCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { md: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "productName" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入产品名称" },
                        model: {
                          value: _vm.form.productName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "productName", $$v)
                          },
                          expression: "form.productName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { md: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "orderStartTime" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetime",
                          placeholder: "请选择订单开始时间",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.form.orderStartTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "orderStartTime", $$v)
                          },
                          expression: "form.orderStartTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { md: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "orderEndTime" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetime",
                          placeholder: "请选择订单结束时间",
                          "default-time": "23:59:59",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.form.orderEndTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "orderEndTime", $$v)
                          },
                          expression: "form.orderEndTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { staticStyle: { "text-align": "right" }, attrs: { md: 14 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: { click: _vm.search },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh" },
                      on: {
                        click: function ($event) {
                          return _vm.reset("form")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-button", { staticClass: "md20", on: { click: _vm.add } }, [
        _vm._v("设置为特殊订单"),
      ]),
      _c(
        "vxe-table",
        {
          ref: "xCheckTable",
          staticClass: "md20",
          attrs: {
            "row-id": "id",
            "edit-config": { trigger: "click", mode: "cell" },
            data: _vm.tableData,
          },
          on: {
            "checkbox-all": function (ref) {
              var records = ref.records

              return _vm.selectAllEvent({ records: records })
            },
            "checkbox-change": function (ref) {
              var records = ref.records

              return _vm.selectChangeEvent({ records: records })
            },
          },
        },
        [
          _c("vxe-table-column", { attrs: { type: "checkbox", width: "50" } }),
          _c("vxe-table-column", {
            attrs: { field: "orderCode", title: "订单编码" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "orderTypeName", title: "订单类型" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "productCode", title: "产品编码" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "productName", title: "产品名称" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "responseBranchName", title: "分公司" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "createDateAll", title: "订单时间" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "businessTypeName", title: "业务类型" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "companyName", title: "公司主体" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "responseName", title: "负责人" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "page-pageination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.tablePage.currentPage,
              "page-sizes": [5, 10, 15, 20, 50, 100, 150, 200],
              "page-size": _vm.tablePage.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tablePage.totalResult,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "huobu_title yibuhuo_title" }, [
        _vm._v("特殊订单"),
      ]),
      _c(
        "el-form",
        { ref: "formBusiness", attrs: { inline: "", model: _vm.formBusiness } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { md: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "orderCode" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入订单编码" },
                        model: {
                          value: _vm.formBusiness.orderCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.formBusiness, "orderCode", $$v)
                          },
                          expression: "formBusiness.orderCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { md: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "productCode" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入产品编码" },
                        model: {
                          value: _vm.formBusiness.productCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.formBusiness, "productCode", $$v)
                          },
                          expression: "formBusiness.productCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { md: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "productName" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入产品名称" },
                        model: {
                          value: _vm.formBusiness.productName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formBusiness, "productName", $$v)
                          },
                          expression: "formBusiness.productName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { md: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "orderStartTime" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetime",
                          placeholder: "请选择订单开始时间",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.formBusiness.orderStartTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.formBusiness, "orderStartTime", $$v)
                          },
                          expression: "formBusiness.orderStartTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { md: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "orderEndTime" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetime",
                          placeholder: "请选择订单结束时间",
                          "default-time": "23:59:59",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.formBusiness.orderEndTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.formBusiness, "orderEndTime", $$v)
                          },
                          expression: "formBusiness.orderEndTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { staticStyle: { "text-align": "right" }, attrs: { md: 14 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: { click: _vm.searchBusiness },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh" },
                      on: {
                        click: function ($event) {
                          return _vm.resetBusiness("formBusiness")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-button", { staticClass: "md20", on: { click: _vm.tableDel } }, [
        _vm._v("取消特殊订单"),
      ]),
      _c("el-button", { staticClass: "md20", on: { click: _vm.tableAdd } }, [
        _vm._v("生成奖励池余额"),
      ]),
      _c(
        "vxe-table",
        {
          ref: "xCheckTable",
          staticClass: "md20",
          attrs: {
            "row-id": "id",
            "edit-config": { trigger: "click", mode: "cell" },
            data: _vm.checkTableData,
          },
          on: {
            "checkbox-all": function (ref) {
              var records = ref.records

              return _vm.selectAllEventBusiness({ records: records })
            },
            "checkbox-change": function (ref) {
              var records = ref.records

              return _vm.selectChangeEventBusiness({ records: records })
            },
          },
        },
        [
          _c("vxe-table-column", { attrs: { type: "checkbox", width: "50" } }),
          _c("vxe-table-column", {
            attrs: { field: "orderCode", title: "订单编码" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "orderTypeName", title: "订单类型" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "productCode", title: "产品编码" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "productName", title: "产品名称" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "responseBranchName", title: "分公司" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "createDateAll", title: "订单时间" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "businessTypeName", title: "业务类型" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "companyName", title: "公司主体" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "responseName", title: "负责人" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "page-pageination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.tablePageBusiness.currentPage,
              "page-sizes": [5, 10, 15, 20, 50, 100, 150, 200],
              "page-size": _vm.tablePageBusiness.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tablePageBusiness.totalResult,
            },
            on: {
              "size-change": _vm.handleSizeChangeBusiness,
              "current-change": _vm.handleCurrentChangeBusiness,
            },
          }),
        ],
        1
      ),
      _c(
        "Modal",
        {
          ref: "modalForm",
          attrs: { modalConfig: _vm.modalConfig },
          on: { onClose: _vm.closeModal },
        },
        [
          _c(
            "vxe-table",
            { ref: "xTable", attrs: { data: _vm.ruleList } },
            [
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "productName",
                  title: "产品",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "scanType",
                  title: "奖励动作",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择奖励动作",
                              disabled: "",
                            },
                            model: {
                              value: row.scanType,
                              callback: function ($$v) {
                                _vm.$set(row, "scanType", $$v)
                              },
                              expression: "row.scanType",
                            },
                          },
                          _vm._l(_vm.rewardAction, function (item) {
                            return _c("el-option", {
                              key: item.dictCode,
                              attrs: {
                                label: item.dictValue,
                                value: item.dictCode,
                              },
                            })
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "beneficiary",
                  title: "奖励对象",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择奖励对象",
                              disabled: "",
                            },
                            model: {
                              value: row.beneficiary,
                              callback: function ($$v) {
                                _vm.$set(row, "beneficiary", $$v)
                              },
                              expression: "row.beneficiary",
                            },
                          },
                          _vm._l(_vm.rewardObject, function (item) {
                            return _c("el-option", {
                              key: item.dictCode,
                              attrs: {
                                label: item.dictValue,
                                value: item.dictCode,
                              },
                            })
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "awardMoney",
                  title: "奖励金额",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input-number", {
                          attrs: {
                            label: "奖励金额",
                            step: 0.0001,
                            precision: 4,
                          },
                          model: {
                            value: row.awardMoney,
                            callback: function ($$v) {
                              _vm.$set(row, "awardMoney", $$v)
                            },
                            expression: "row.awardMoney",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  fixed: "right",
                  title: "操作",
                  align: "center",
                  width: "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var rowIndex = ref.rowIndex
                      return [
                        _c("el-button", {
                          staticClass: "text-red",
                          attrs: {
                            slot: "reference",
                            type: "text",
                            icon: "el-icon-delete",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteRule(rowIndex)
                            },
                          },
                          slot: "reference",
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-check",
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("提交")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    size: "small",
                    icon: "el-icon-close",
                  },
                  on: { click: _vm.closeModal },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }